import React, { useState, useEffect, useCallback } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { Outlet, useLocation } from 'react-router-dom';

const pageTitles = {
  '/dashboard': { title: 'Dashboard', subtitle: 'Welcome back! Here\'s what\'s happening.' },
  '/students': { title: 'Student Management', subtitle: 'Manage student admissions and profiles' },
  '/classes': { title: 'Classes & Sections', subtitle: 'Manage classes, sections, and academic years' },
  '/staff': { title: 'Staff Management', subtitle: 'Manage teachers and staff' },
  '/departments': { title: 'Departments', subtitle: 'Organise staff into departments and assign heads' },
  '/academic': { title: 'Academic Management', subtitle: 'Classes, subjects, timetables & more' },
  '/examination': { title: 'Examination & Results', subtitle: 'Manage exams, marks, and report cards' },
  '/fees': { title: 'Fee Management', subtitle: 'Fee collection, structures and dues' },
  '/attendance': { title: 'Attendance Management', subtitle: 'Track student and staff attendance' },
  '/communication': { title: 'Communication', subtitle: 'Announcements, messages, and notices' },
  '/transport': { title: 'Transport Management', subtitle: 'Routes, vehicles, and drivers' },
  '/library': { title: 'Library Management', subtitle: 'Books, issues, and inventory' },
  '/hostel': { title: 'Hostel Management', subtitle: 'Rooms, allocations, and mess' },
  '/reports': { title: 'Reports & Analytics', subtitle: 'Performance and financial insights' },
  '/admin': { title: 'Administration', subtitle: 'Users, roles, and system settings' },
  '/id-cards-config': { title: 'Id Cards & Certificates Configutation', subtitle: 'Configurate Id Cards & Certifcates' },
  '/profile': { title: 'Profile', subtitle: 'Profile and Password changes' },
  '/branches': { title: 'Institute registration and Branchs ', subtitle: 'Institute Imformation & Branches ' },
};

const MOBILE_BREAKPOINT = 992;

const AppLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopCollapsed, setDesktopCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);
  const [menuOpen, setMenuOpen] = useState(false);


  const location = useLocation();
  const pageInfo = pageTitles[location.pathname] || { title: 'School Management System' };

  useEffect(() => {
    const handleResize = () => {
      const nowMobile = window.innerWidth < MOBILE_BREAKPOINT;
      setIsMobile(nowMobile);
      if (nowMobile) setDesktopCollapsed(false);
      else setMobileOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleMenuToggle = useCallback(() => {
    if (isMobile) setMobileOpen((prev) => !prev);
    else setDesktopCollapsed((prev) => !prev);
  }, [isMobile]);

  const handleSidebarClose = useCallback(() => {
    if (isMobile) setMobileOpen(false);
  }, [isMobile]);

  // derived AFTER the state it depends on is declared
  const isMenuOpen = isMobile ? mobileOpen : !desktopCollapsed;

  return (
    <div className="app-wrapper" style={{ display: 'flex', height: '100vh', width: '100%', overflow: 'hidden' }}>
      <Sidebar
        collapsed={desktopCollapsed}
        mobileOpen={mobileOpen}
        isMobile={isMobile}
        onClose={handleSidebarClose}
      />

      {mobileOpen && isMobile && (
        <div
          onClick={() => setMobileOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1039 }}
        />
      )}

      <div
        className="main-content"
        style={{ flex: '1 1 auto', minWidth: 0, height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
      >
        <Topbar
          onMenuToggle={handleMenuToggle}
          menuOpen={isMenuOpen}
          title={pageInfo.title}
          subtitle={pageInfo.subtitle}
        />
        <div className="page-content" style={{ flex: '1 1 auto', overflowY: 'auto' }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AppLayout;